export class VSaveDireccionAndAsociateModel {

  constructor(
    public direccion: string = '',
    public codigopostal: number = 0,
    public municipio: string = '',
    public provincia: number = 0,
    public telefono: number = null,
    public idCentro: number = 0
  ) {}
}
